var map = {
	"./Badges.abi.js": 322,
	"./ENS.abi.js": 231,
	"./ENSResolver.abi.js": 232,
	"./ERC20Vendable.abi.js": 323,
	"./Emitter.abi.js": 233,
	"./Exchange.abi.js": 230,
	"./GnosisSafe.abi.js": 324,
	"./Links.abi.js": 325,
	"./LinksNFT.abi.js": 326,
	"./ProxyFactory.abi.js": 327,
	"./SafeBeacon.abi.js": 328,
	"./StableCoin.abi.js": 234,
	"./VendingMachine.abi.js": 329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;